import { render } from "./confirmremove.vue?vue&type=template&id=637300af"
import script from "./confirmremove.vue?vue&type=script&lang=js"
export * from "./confirmremove.vue?vue&type=script&lang=js"

import "./confirmremove.vue?vue&type=style&index=0&id=637300af&lang=css"

import exportComponent from "/home/runner/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__